import React, { useEffect, useState } from 'react';

import { copyToClipboard } from 'lib/utils';
import { MFA_APP_KEY } from 'lib/mfa';
import { ActionButton, ButtonV2, Icon, Preloader } from 'components';

function SetupApp({ onPrevious, onContinue, currentQrCode, currentOtpSecret }) {
  const [otpSecret, setOtpSecret] = useState(currentOtpSecret);
  const [qrCode, setQrCode] = useState(currentQrCode);

  useEffect(() => {
    if (otpSecret) return;

    req
      .mfaCreateAuthenticator({ kind: MFA_APP_KEY })
      .then(result => {
        if (result) {
          setOtpSecret(result.otp_secret);
          setQrCode(result.qr_code);
        }
      })
      .catch(() => {
        setOtpSecret(null);
        setQrCode(null);
      });
  }, []);

  const copySecret = () => {
    copyToClipboard(otpSecret);
  };

  return (
    <>
      <div className="modal__header mfa-add-method">
        <div className="modal__header-title">
          <ActionButton iconName="back" size={14} onClick={onPrevious} />
          Set Up Authenticator App{' '}
          <label>
            <strong>Step 2</strong> / 3
          </label>
        </div>
      </div>
      <div className="modal__container">
        <div className="mfa-add-method__description">
          STEP 1:
          <br />
          Download or use an existing Authenticator App installed on your device.
        </div>
        <div className="mfa-add-method__description">
          STEP 2:
          <br />
          Scan the QR code below using your Authenticator app or enter the code to link your Procare Account.
        </div>
        {qrCode && (
          <div className="mfa-add-method__qr-code">
            <img src={qrCode} alt="QR Code" />
          </div>
        )}
        {!otpSecret && <Preloader />}
        {otpSecret && (
          <div className="mfa-add-method__secret-container">
            <div className="mfa-add-method__secret">
              <label>{otpSecret}</label>
              <Icon name="copy" size={20} color="#777" onClick={copySecret} />
            </div>
          </div>
        )}
      </div>
      <div data-testid="auth-app-tip" className="mfa-add-method__tip">
        <div>
          <strong>*Configuration Tip:</strong> If additional configuration settings are available when setting up your
          authenticator app, set the Code Type to <strong>6 Digits</strong> with a <strong>Time-Based (TOTP)</strong>{' '}
          Key Type.
        </div>
      </div>
      <div className="modal__footer">
        <ButtonV2
          className="button--primary"
          label="Verify Authenticator App"
          onClick={() => onContinue({ qrCode, otpSecret })}
        />
      </div>
    </>
  );
}

export default SetupApp;
